import type { TourStep } from './types';

export const wildberriesSteps: TourStep[] = [
  {
    target: 'body',
    title: 'Добро пожаловать в интеграцию Wildberries',
    content: 'Здесь вы можете управлять синхронизацией товаров с маркетплейсом Wildberries: загружать товары, обновлять цены и остатки, отслеживать статусы.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="wb-seller-select"]',
    title: 'Выбор продавца',
    content: 'Если у вас несколько кабинетов Wildberries, выберите нужного продавца из списка. Все данные будут загружены для выбранного кабинета.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="wb-stats"]',
    title: 'Статистика',
    content: 'Здесь отображается общее количество товаров в выбранном кабинете Wildberries.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="wb-sync-btn"]',
    title: 'Синхронизация с Wildberries',
    content: 'Нажмите эту кнопку для загрузки актуальных данных о товарах из вашего кабинета Wildberries. Процесс может занять несколько минут.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="wb-filter-status"]',
    title: 'Фильтр по статусу',
    content: 'Фильтруйте товары по статусу на маркетплейсе: активные, архивные, с ошибками и т.д.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="wb-products-table"]',
    title: 'Таблица товаров Wildberries',
    content: 'Список всех товаров из вашего кабинета WB. Кликните на товар для просмотра подробностей.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="wb-pagination"]',
    title: 'Навигация',
    content: 'Используйте пагинацию для просмотра всех товаров. Выберите количество товаров на странице для удобства.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: 'body',
    title: 'Готово!',
    content: 'Теперь вы знаете основные функции интеграции с Wildberries. Регулярно синхронизируйте данные для актуальности информации. Удачных продаж!',
    placement: 'center',
    disableBeacon: true,
  },
];
